var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#3C2190",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#F6F5F8",
    strokeOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6887 29.5H24.3104C24.7647 29.5 25.2004 29.3195 25.5216 28.9983C25.8428 28.6771 26.0233 28.2414 26.0233 27.7871V19.222H8.97572V27.7871C8.97572 28.2414 9.15619 28.6771 9.47743 28.9983C9.79867 29.3195 10.2344 29.5 10.6887 29.5ZM7.91113 16.0458V18.3449H27.0887V16.0458C27.0887 15.5915 26.9083 15.1558 26.587 14.8345C26.2658 14.5133 25.8301 14.3328 25.3758 14.3328H20.3616C22.743 14.3328 26.1672 12.0216 25.4169 9.57085C24.7904 7.52346 22.91 6.48799 20.9886 6.49998C18.2757 6.5154 17.5725 12.2028 17.5725 12.2028H17.4997C17.4997 12.2028 16.797 6.5154 14.0837 6.49998C12.1618 6.48799 10.2818 7.52346 9.65533 9.57085C8.90464 12.0216 12.3292 14.3328 14.7115 14.3328H9.62407C9.16977 14.3328 8.73408 14.5133 8.41284 14.8345C8.0916 15.1558 7.91113 15.5915 7.91113 16.0458ZM22.9837 8.56707C22.9837 8.56707 22.8998 11.366 19.1386 13.4562C19.139 13.4562 19.8494 9.86291 22.9837 8.56707ZM12.1202 8.56707C15.2536 9.86248 15.9641 13.4562 15.9641 13.4562C12.2038 11.366 12.1202 8.56707 12.1202 8.56707Z",
    fill: "#F6F5F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.fcda89b08589ab60e99abff4297b0df9.svg";
export { ForwardRef as ReactComponent };